// @ts-nocheck
import * as React from 'react';
import styled from 'styled-components';

import { Row, Col } from 'crehana-ui/GridV2';
import { greenMain } from 'crehana-ui/styles/colors';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';
import CheckNew from 'crehana-icons/CheckNew';
import Price from 'crehana-ui/Text/Price';
import { blueDark, blueMain, purpleLighter56 } from 'crehana-ui/styles/colors';

import useMediaQuery from 'Shared/Hooks/useMediaQuery';

import { Product as ProductType } from '../types';
import BasicInfo from './BasicInfo';

const StyledDiv = styled.div<{
  bigImage: string;
  shortGradient?: boolean;
}>`
  border-top: 4px solid;
  border-image-source: linear-gradient(90.03deg, #05be50 0%, #0039a6 100%);
  border-image-slice: 1;
  background-image: linear-gradient(0deg, ${blueMain}, ${blueMain}),
    linear-gradient(161.77deg, ${blueDark} 53.89%, ${purpleLighter56} 87.61%);
  @media (min-width: 768px) {
    background-size: cover;
    background-position: center;
    background-image: linear-gradient(
        90deg,
        rgb(15, 17, 36) 33%,
        rgba(11, 11, 12, 0) 100%
      ),
      url(${props => props.bigImage});
  }
`;

const Product: React.FC<{
  product: ProductType;
  isLast: boolean;
}> = ({ product, isLast }) => {
  const { matches } = useMediaQuery('sm');
  const [canRenderPromo, setCanRenderPromo] = React.useState(false);

  React.useEffect(() => {
    if (window.location.href.includes('cyber-interbank')) {
      setCanRenderPromo(true);
    }
  }, []);

  return (
    <StyledDiv
      className="mb-48 sm:mb-32 lg:mb-80 px-24 py-24 flex flex-col relative text-center overflow-hidden sm:py-40 sm:px-0 lg:py-40"
      bigImage={
        canRenderPromo && isLast
          ? 'https://crehana-public-catalog.imgix.net/images/page/membership/background_images/1eaba6e9/360bb07e.png'
          : product.backgroundImage.big
      }
    >
      <Row className="items-end">
        <Col className="text-center sm:text-left" xs={12} sm={6} md={5}>
          <BasicInfo
            product={product}
            canRenderBuyButton={matches}
            canShowPrice={matches}
          />
        </Col>
        {/* Benefits */}
        <Col xs={12} sm={5} md={6} offset={{ sm: 1, md: 1 }}>
          <div className="mt-24 sm:mt-0">
            <p className="font-subtitle2 text-white mb-8 text-center sm:text-left">
              Beneficios:
            </p>
            <ul>
              {product.benefits.map(benefit => (
                <li
                  key={benefit.originalId}
                  className="flex items-center mb-8"
                  color="white"
                >
                  <CheckNew size={20} color={greenMain} />
                  <p className="font-body2 text-white ml-8 text-left">
                    {benefit.text}
                  </p>
                </li>
              ))}
            </ul>
          </div>
          {/* Mobile price */}
          {product.prices && (
            <Price
              s
              className="mt-24 sm:hidden"
              currency={product.prices.currency}
              price={product.prices.price}
              priceColor="white"
              realPriceColor="white"
              currencyColor="white"
              realPrice={product.prices.realPrice}
            />
          )}
          {/* Mobile buy button */}
          <PrimaryButton
            className="mt-24 sm:hidden"
            darkMode
            full={!matches}
            label={product.buttonLabel}
            size="l"
            onClick={() => {
              window.location.href = product.url;
            }}
          />
          {/* Mobile promo */}
          {canRenderPromo && (
            <p className="block sm:hidden font-button text-yellow-main mt-24">
              Disponible con tu cupón
            </p>
          )}
        </Col>
      </Row>
      {/* Desktop promo */}
      {canRenderPromo && (
        <p className="hidden sm:inline-block font-button text-yellow-main text-left mt-24">
          Disponible con tu cupón
        </p>
      )}
    </StyledDiv>
  );
};

export default Product;
